import React from 'react';
import { TextField, Button } from '../layout';

const OrderEditForm = ({
    formData,
    handleInputChange,
    errors,
    clients,
    agents,
    currentOrder,
    handleSubmit,
    onCancel
}) => {
    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField
                    id="InternalOrdNo"
                    name="InternalOrdNo"
                    label="Numero Ordine Interno"
                    value={formData.InternalOrdNo}
                    onChange={handleInputChange}
                    error={errors.InternalOrdNo}
                    required
                    disabled={!!currentOrder}
                />
                <TextField
                    id="ExternalOrdNo"
                    name="ExternalOrdNo"
                    label="Numero Ordine APP"
                    value={formData.ExternalOrdNo}
                    onChange={handleInputChange}
                    error={errors.ExternalOrdNo}
                />
                <TextField
                    id="OrderDate"
                    name="OrderDate"
                    label="Data Ordine"
                    type="date"
                    value={formData.OrderDate}
                    onChange={handleInputChange}
                    error={errors.OrderDate}
                    required
                />
                <TextField
                    id="ConfirmedDeliveryDate"
                    name="ConfirmedDeliveryDate"
                    label="Data Conferma"
                    type="date"
                    value={formData.ConfirmedDeliveryDate}
                    onChange={handleInputChange}
                    error={errors.ConfirmedDeliveryDate}
                    helperText="Lasciare vuoto se l'ordine non è confermato"
                />

                <div className="form-group">
                    <label htmlFor="Customer" className="block text-sm font-medium text-gray-700 mb-1">
                        Cliente <span className="text-red-500">*</span>
                    </label>
                    <select
                        id="Customer"
                        name="Customer"
                        value={formData.Customer}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border ${errors.Customer ? 'border-red-300' : 'border-gray-200'} rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50`}
                        required
                    >
                        <option value="">Seleziona cliente</option>
                        {clients.map(client => (
                            <option key={client.CustSupp} value={client.CustSupp}>
                                {client.CompanyName} ({client.CustSupp})
                            </option>
                        ))}
                    </select>
                    {errors.Customer && (
                        <div className="flex items-center mt-1 text-sm text-red-600">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.Customer}
                        </div>
                    )}
                </div>

                <TextField
                    id="OurReference"
                    name="OurReference"
                    label="Nostro Riferimento"
                    value={formData.OurReference}
                    onChange={handleInputChange}
                    error={errors.OurReference}
                />

                <div className="form-group">
                    <label htmlFor="PriceList" className="block text-sm font-medium text-gray-700 mb-1">
                        Listino Prezzi
                    </label>
                    <select
                        id="PriceList"
                        name="PriceList"
                        value={formData.PriceList}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border border-gray-200 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50"
                    >
                        <option value="PR">PR (Italia)</option>
                        <option value="PR-E">PR-E (Estero)</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="Salesperson" className="block text-sm font-medium text-gray-700 mb-1">
                        Agente <span className="text-red-500">*</span>
                    </label>
                    <select
                        id="Salesperson"
                        name="Salesperson"
                        value={formData.Salesperson}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-2.5 bg-white/5 backdrop-blur-sm border ${errors.Salesperson ? 'border-red-300' : 'border-gray-200'} rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-red-500 focus:ring-red-500/50`}
                        required
                    >
                        <option value="">Seleziona agente</option>
                        {agents.map(agent => (
                            <option key={agent.Salesperson} value={agent.Salesperson}>
                                {agent.Name} ({agent.Salesperson})
                            </option>
                        ))}
                    </select>
                    {errors.Salesperson && (
                        <div className="flex items-center mt-1 text-sm text-red-600">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.Salesperson}
                        </div>
                    )}
                </div>

                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Stato Consegna
                        </label>
                        <div className="flex items-center space-x-4 mt-2">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Delivered"
                                    value="0"
                                    checked={formData.Delivered === '0'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Non consegnato</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Delivered"
                                    value="1"
                                    checked={formData.Delivered === '1'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Consegnato</span>
                            </label>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Stato Fatturazione
                        </label>
                        <div className="flex items-center space-x-4 mt-2">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Invoiced"
                                    value="0"
                                    checked={formData.Invoiced === '0'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Non fatturato</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Invoiced"
                                    value="1"
                                    checked={formData.Invoiced === '1'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Fatturato</span>
                            </label>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Stato Ordine
                        </label>
                        <div className="flex items-center space-x-4 mt-2">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Cancelled"
                                    value="0"
                                    checked={formData.Cancelled === '0'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Attivo</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    name="Cancelled"
                                    value="1"
                                    checked={formData.Cancelled === '1'}
                                    onChange={handleInputChange}
                                    className="form-radio h-4 w-4 text-red-600"
                                />
                                <span className="ml-2 text-sm text-gray-700">Annullato</span>
                            </label>
                        </div>
                    </div>
                </div>

                <TextField
                    id="TaxableAmount"
                    name="TaxableAmount"
                    label="Imponibile"
                    type="number"
                    inputMode="decimal"
                    step="0.01"
                    value={formData.TaxableAmount}
                    onChange={handleInputChange}
                    error={errors.TaxableAmount}
                    required
                />

                <TextField
                    id="TaxAmount"
                    name="TaxAmount"
                    label="IVA"
                    type="number"
                    inputMode="decimal"
                    step="0.01"
                    value={formData.TaxAmount}
                    onChange={handleInputChange}
                    error={errors.TaxAmount}
                    required
                />

                <TextField
                    id="PayableAmount"
                    name="PayableAmount"
                    label="Totale da Pagare"
                    type="number"
                    inputMode="decimal"
                    step="0.01"
                    value={formData.PayableAmount}
                    onChange={handleInputChange}
                    error={errors.PayableAmount}
                    required
                />
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={onCancel}
                >
                    Annulla
                </Button>
                <Button
                    type="submit"
                    color="primary"
                >
                    {currentOrder ? "Aggiorna" : "Salva"}
                </Button>
            </div>
        </form>
    );
};

export default OrderEditForm;